<template>
  <router-link :to="newsHref" :class="[$style.news, $style.link]">
    <time :class="$style.news__datetime" :datetime="publishedAtISO">{{
      publishedAt
    }}</time>
    <p :class="[$style.link__emphasizableText, $style.news__description]">
      {{ adminNewsListItem.title }}
    </p>
  </router-link>
</template>

<script lang="ts" setup>
import { formatDate } from '@/libs/utilities/formatDate'
import { type AdminNewsListItemNewsForPlannerFragment } from './AdminNewsListItem.generated'
import { computed } from 'vue'
import { useEntranceGUIDParam } from '@/features/entrance/useEntranceGUIDParam'

const props = defineProps<{
  adminNewsListItem: AdminNewsListItemNewsForPlannerFragment
}>()

// AdminNewsListItem は複数のルートで使用されるため、entranceGUID の取得にあたって useRoute ではなく useEntranceGUIDParam を使用する
const { entranceGUID } = useEntranceGUIDParam({ must: true })

const publishedAtISO = computed(() => {
  return new Date(props.adminNewsListItem.publishedAt).toISOString()
})

const publishedAt = computed(() => {
  return formatDate(new Date(props.adminNewsListItem.publishedAt))
})

const newsHref = computed(() => {
  return {
    name: 'newsDetail' as const,
    params: {
      entranceGUID: entranceGUID.value,
      newsId: props.adminNewsListItem.id.toString(),
    },
  }
})
</script>

<style lang="scss" module>
.link {
  $root: &;

  &:hover {
    text-decoration: none;
  }

  &__emphasizableText {
    #{$root}:hover & {
      text-decoration: underline;
    }
  }
}

.news {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 32px 0;

  &__datetime {
    width: 6.5em;
    color: $color-text-and-object-high-emphasis;
    font-size: 16px;
    font-weight: bold;
  }

  &__description {
    flex-grow: 1;
    color: $color-text-and-object-accent-primary;
    font-size: 16px;

    &:nth-child(n + 2) {
      margin-left: 32px;
    }
  }
}
</style>
